export default __webpack_public_path__ + "static/media/researchgate.7aae8300.png";